module.exports = __webpack_public_path__ + "img/pic_500.f3d0983e.svg";